export interface GossipCard {
  id: string;
  tag: string;          // 证据类别：截图/录音/视频/线索/实锤
  category: string;     // 栏目
  title: string;
  summary: string;
  author: string;
  date: string;
  views: string;
  hot: number;
  image: string;
  badge: string;
}

export interface NewsRow {
  id: string;
  tag: string;
  title: string;
  time: string;
  category: string;
  hot: number;
  highlight?: boolean;
}

export interface RankItem {
  id: string;
  word: string;
  delta: number; // 热度变化，正为升负为降
  heat: number;
  category: string;
  state: 'up' | 'down' | 'flat' | 'new';
}

export interface Topic {
  id: string;
  name: string;
  count: string;
  trend: string;
}

export interface FAQ {
  id: string;
  q: string;
  a: string;
}

export const navItems = [
  { key: 'zhuizong', label: '最新追踪' },
  { key: 'shichui', label: '实锤速递' },
  { key: 'zhengju', label: '证据检索' },
  { key: 'paixing', label: '热度榜单' },
  { key: 'changjing', label: '场景档案' },
  { key: 'wenda', label: '吃瓜问答' },
];

export const featureNews: NewsRow[] = [
  {
    id: 'f1',
    tag: '新实锤',
    title: '跨平台对比：同一时间轴下三条线索指向同一关键节点',
    time: '今日 10:24',
    category: '线索链',
    hot: 986,
    highlight: true,
  },
  {
    id: 'f2',
    tag: '新截图',
    title: '聊天记录截图疑被裁剪，时间戳与上下文首次并排对照',
    time: '今日 09:47',
    category: '图文证据',
    hot: 872,
  },
  {
    id: 'f3',
    tag: '新录音',
    title: '音频声纹比对初稿公开，环境噪声成判定突破口',
    time: '今日 08:58',
    category: '声音鉴定',
    hot: 731,
  },
  {
    id: 'f4',
    tag: '新视频',
    title: '现场视频帧级拆解，画面细节与前期说法出现出入',
    time: '昨日 22:31',
    category: '影像解析',
    hot: 654,
  },
  {
    id: 'f5',
    tag: '新线索',
    title: '匿名信源提供的节点信息，正在做交叉核验',
    time: '昨日 21:15',
    category: '人物关系',
    hot: 598,
  },
];

export const evidenceCards: GossipCard[] = [
  {
    id: 'e1',
    tag: '实锤',
    category: '图文证据',
    title: '「新截图」关键会话记录全文核对：删改与补全并存',
    summary: '通过放大缩略图并比对两版导出文件，发现同一段对话存在顺序差异，目前已对齐第三方存档重新梳理。',
    author: '瓜情组 · 取证分站',
    date: '2026-09-06',
    views: '18.2万',
    hot: 96,
    image: 'https://readdy.ai/api/search-image?query=stylized%20editorial%20collage%20of%20chat%20conversation%20screenshots%2C%20bubbles%20and%20time%20stamps%2C%20warm%20coral%20and%20jade%20graphic%20shapes%20on%20cream%20paper%20background%2C%20media%20forensic%20documentary%20aesthetic%2C%20flat%20illustration%2C%20high%20detail%2C%20no%20real%20text&width=800&height=500&seq=gossip-evidence-01&orientation=landscape',
    badge: '已核验',
  },
  {
    id: 'e2',
    tag: '实锤',
    category: '声音鉴定',
    title: '「新录音」声纹初筛结果公开：环境音辅助定级',
    summary: '技术组对原始音频做频谱分段，重点比对环境噪声连续性，结果将用于判断录音是否经过二次拼接。',
    author: '声纹实验室',
    date: '2026-09-06',
    views: '14.7万',
    hot: 91,
    image: 'https://readdy.ai/api/search-image?query=stylized%20audio%20waveform%20and%20microphone%20sound%20spectrum%20illustration%2C%20jade%20green%20and%20coral%20lines%20on%20cream%20background%2C%20forensic%20audio%20analysis%2C%20flat%20editorial%20graphic%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=gossip-evidence-02&orientation=landscape',
    badge: '初稿',
  },
  {
    id: 'e3',
    tag: '实锤',
    category: '影像解析',
    title: '「新视频」帧级拆解：画面细节还原事件现场',
    summary: '将视频逐帧放大处理，画面中的时钟、倒影与反光成为重要参照，已与前期公开说法逐条对照。',
    author: '影像还原组',
    date: '2026-09-05',
    views: '21.3万',
    hot: 88,
    image: 'https://readdy.ai/api/search-image?query=stylized%20video%20playback%20frames%20with%20timeline%20scrubber%20illustration%2C%20coral%20and%20amber%20tones%20on%20cream%20background%2C%20frame%20by%20frame%20forensic%20video%20review%2C%20flat%20editorial%20graphic%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=gossip-evidence-03&orientation=landscape',
    badge: '已核验',
  },
  {
    id: 'e4',
    tag: '线索',
    category: '人物关系',
    title: '「新线索」第三方时间轴曝光：多节点出现重叠',
    summary: '结合地理位置与社交动态整理出人物动线，发现若干时间点存在空白窗口，正在寻找补位证据。',
    author: '线索梳理组',
    date: '2026-09-05',
    views: '9.8万',
    hot: 82,
    image: 'https://readdy.ai/api/search-image?query=stylized%20timeline%20and%20location%20pin%20network%20diagram%20illustration%2C%20jade%20nodes%20connecting%20coral%20dots%20on%20cream%20paper%2C%20data%20linkage%20analysis%2C%20flat%20editorial%20graphic%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=gossip-evidence-04&orientation=landscape',
    badge: '待核验',
  },
  {
    id: 'e5',
    tag: '实锤',
    category: '图文证据',
    title: '原图信息恢复：拍摄设备与坐标隐含关键信息',
    summary: '通过恢复原始图片的拍摄参数，获知拍摄设备型号与大致位置，为时间线提供了更扎实的锚点。',
    author: '图鉴小组',
    date: '2026-09-04',
    views: '12.1万',
    hot: 79,
    image: 'https://readdy.ai/api/search-image?query=stylized%20magnifying%20glass%20over%20photo%20metadata%20and%20camera%20grid%20illustration%2C%20cream%20background%20with%20coral%20and%20jade%20accents%2C%20image%20forensics%2C%20flat%20editorial%20style%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=gossip-evidence-05&orientation=landscape',
    badge: '已核验',
  },
  {
    id: 'e6',
    tag: '线索',
    category: '时间线重构',
    title: '多位匿名投稿交叉印证，事件脉络浮出水面',
    summary: '将不同来源的匿名线索对齐后，事件的整体推进节奏逐渐清晰，部分叙述仍存在口径差异待统一。',
    author: '综合研判组',
    date: '2026-09-04',
    views: '11.5万',
    hot: 74,
    image: 'https://readdy.ai/api/search-image?query=stylized%20crossing%20paths%20and%20intersecting%20lines%20with%20question%20marks%20illustration%2C%20warm%20coral%20and%20sand%20tones%20on%20cream%20background%2C%20investigation%20mind%20map%2C%20flat%20editorial%20graphic%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=gossip-evidence-06&orientation=landscape',
    badge: '待核验',
  },
];

export const evidenceTags = ['全部', '实锤', '线索'];

export const feedRows: NewsRow[] = [
  { id: 'r1', tag: '新截图', title: '关于「口径不一致」的补充说明与证据归档说明', time: '12分钟前', category: '站内公告', hot: 512 },
  { id: 'r2', tag: '新录音', title: '一段被反复转发的音频，初步听辨结果已公布', time: '36分钟前', category: '声音鉴定', hot: 486 },
  { id: 'r3', tag: '新线索', title: '多位网友晒出同款画面，形成新的证据集合', time: '1小时前', category: '图文证据', hot: 459 },
  { id: 'r4', tag: '新视频', title: '现场画面补拍视角曝光，与前版差异引发讨论', time: '2小时前', category: '影像解析', hot: 433 },
  { id: 'r5', tag: '新实锤', title: '时间线第三版整理上线，新增两处关键坐标', time: '3小时前', category: '时间线重构', hot: 411 },
  { id: 'r6', tag: '新截图', title: '被删除的旧帖截图被重新发现，内容前后矛盾', time: '4小时前', category: '图文证据', hot: 388 },
  { id: 'r7', tag: '线索', title: '投稿专区新增「匿名投稿」入口，支持音频上传', time: '5小时前', category: '站内公告', hot: 365 },
  { id: 'r8', tag: '新实锤', title: '多方交叉核验完成度报告：目前进展如何', time: '6小时前', category: '综合研判', hot: 342 },
  { id: 'r9', tag: '新录音', title: '不同来源音频的音质差异分析，判断生成环境', time: '7小时前', category: '声音鉴定', hot: 318 },
  { id: 'r10', tag: '新视频', title: '慢放处理后的画面，出现了此前未被注意的细节', time: '8小时前', category: '影像解析', hot: 296 },
];

export const ranks: RankItem[] = [
  { id: 'rk1', word: '事件时间线完整版', delta: 2, heat: 100, category: '事件复盘', state: 'up' },
  { id: 'rk2', word: '音频声纹鉴定报告', delta: 0, heat: 96, category: '技术鉴定', state: 'flat' },
  { id: 'rk3', word: '关键截图高清原图', delta: 1, heat: 93, category: '图文证据', state: 'up' },
  { id: 'rk4', word: '现场画面帧级拆解', delta: -1, heat: 89, category: '影像解析', state: 'down' },
  { id: 'rk5', word: '匿名投稿专区', delta: 6, heat: 85, category: '投稿入口', state: 'new' },
  { id: 'rk6', word: '人物关系梳理图', delta: -2, heat: 82, category: '线索整理', state: 'down' },
  { id: 'rk7', word: '网友证据汇总帖', delta: 3, heat: 78, category: '聚合讨论', state: 'up' },
  { id: 'rk8', word: '关键时间点对照表', delta: 0, heat: 74, category: '事件复盘', state: 'flat' },
  { id: 'rk9', word: '前期说法逐条核对', delta: -1, heat: 71, category: '综合研判', state: 'down' },
  { id: 'rk10', word: '投稿音视频鉴别指南', delta: 4, heat: 68, category: '方法科普', state: 'up' },
];

export const topics: Topic[] = [
  { id: 'tp1', name: '#声纹比对', count: '3.2万讨论', trend: '热度 +42%' },
  { id: 'tp2', name: '#时间线完整版', count: '2.8万讨论', trend: '热度 +31%' },
  { id: 'tp3', name: '#原图溯源', count: '1.9万讨论', trend: '热度 +25%' },
  { id: 'tp4', name: '#口径对比', count: '1.6万讨论', trend: '热度 +18%' },
  { id: 'tp5', name: '#匿名投稿', count: '1.4万讨论', trend: '新增话题' },
  { id: 'tp6', name: '#帧级拆解', count: '1.1万讨论', trend: '热度 +12%' },
  { id: 'tp7', name: '#设备坐标', count: '0.9万讨论', trend: '热度 +9%' },
  { id: 'tp8', name: '#还原真相', count: '0.8万讨论', trend: '热度 +7%' },
];

export const sceneArchives: GossipCard[] = [
  {
    id: 's1',
    tag: '复盘',
    category: '事件全貌',
    title: '从碎片到拼图：我们如何重建这场事件的时间轴',
    summary: '把散落在不同平台的截图、录音与视频片段，像拼图一样逐一归位，最终拼出接近完整的现场图景。',
    author: '主编手记',
    date: '2026-09-05',
    views: '26.5万',
    hot: 99,
    image: 'https://readdy.ai/api/search-image?query=stylized%20jigsaw%20puzzle%20pieces%20assembling%20into%20a%20scene%20illustration%2C%20warm%20cream%20background%20with%20coral%20jade%20and%20sand%20graphic%20shapes%2C%20story%20rebuild%20documentary%2C%20flat%20editorial%20style%2C%20high%20detail%2C%20no%20text&width=1000&height=660&seq=gossip-scene-01&orientation=landscape',
    badge: '深度长文',
  },
  {
    id: 's2',
    tag: '方法',
    category: '鉴别科普',
    title: '普通人如何辨别一张截图是否被 P 过或截断',
    summary: '几个不用专业软件也能上手的检查点：看时间戳、看上下文、看像素边缘，教你做自己的初级取证。',
    author: '技术科普组',
    date: '2026-09-03',
    views: '15.8万',
    hot: 90,
    image: 'https://readdy.ai/api/search-image?query=stylized%20photo%20editing%20layers%20and%20comparison%20tools%20illustration%2C%20cream%20background%2C%20coral%20and%20jade%20ui%20shapes%2C%20fact%20checking%20tutorial%2C%20flat%20editorial%20graphic%2C%20high%20detail%2C%20no%20text&width=1000&height=660&seq=gossip-scene-02&orientation=landscape',
    badge: '方法课',
  },
  {
    id: 's3',
    tag: '风向',
    category: '舆论观察',
    title: '同一段素材为何被解读出完全相反的结论',
    summary: '透过评论区与转发路径，看情绪、立场与断章取义如何在传播中放大，理性吃瓜的第一步是慢下来。',
    author: '舆论观察组',
    date: '2026-09-02',
    views: '12.4万',
    hot: 86,
    image: 'https://readdy.ai/api/search-image?query=stylized%20two%20diverging%20paths%20with%20speech%20bubbles%20and%20arrows%20illustration%2C%20warm%20coral%20and%20sand%20tones%20on%20cream%20background%2C%20public%20opinion%20dynamics%2C%20flat%20editorial%20style%2C%20high%20detail%2C%20no%20text&width=1000&height=660&seq=gossip-scene-03&orientation=landscape',
    badge: '深度观察',
  },
];

export const faqs: FAQ[] = [
  {
    id: 'faq1',
    q: '「实锤」和「线索」有什么区别？',
    a: '「实锤」指已经过多方交叉核验、具备完整证据链的材料，例如对齐了时间戳的原图、通过声纹初筛的音频等；「线索」则指尚未完成验证、但存在参考价值的投稿与旁证。我们会为每一份材料标注核验状态，方便你判断可信度。',
  },
  {
    id: 'faq2',
    q: '这些新截图、新录音和新视频是从哪里来的？',
    a: '材料主要来自读者匿名投稿、公开平台的公开发布内容，以及技术组对网络公开素材的系统整理。所有原始材料我们会保留来源痕迹，并在内容中对可公开的部分做脱敏处理，不会发布未经授权的私人敏感信息。',
  },
  {
    id: 'faq3',
    q: '发布前会如何核验一份证据的真实性？',
    a: '我们的取证流程分为四步：先检查元数据与时间戳是否连贯，再做多方来源交叉印证，必要时借助声纹、影像等基础技术手段，最后由研判组统一口径后才会标记为「实锤」。无法验证的内容会明确标注为「线索」或「待核验」。',
  },
  {
    id: 'faq4',
    q: '我手上有新素材，如何投稿给你们？',
    a: '你可以在页面底部的「投稿」入口提交图片、音频或文字线索，我们建议尽量提供原始文件与来源说明。出于安全考虑，请勿在公开留言中直接暴露第三方隐私，技术组会先进行合规与真实性初筛。',
  },
  {
    id: 'faq5',
    q: '如何理性看待网络流传的各种版本说法？',
    a: '建议优先阅读标注为「已核验」的整理内容，对照「时间线完整版」查看脉络，并对转发的二手截图保持警惕。我们会在每篇深度文章末尾给出「仍需补充」的证据缺口，帮助你把关注点放在事实而非情绪上。',
  },
];

export const siteStats = [
  { label: '累计核验素材', value: '12,480+' },
  { label: '归档事件档案', value: '3,260+' },
  { label: '声纹/影像鉴定', value: '1,870+' },
  { label: '瓜友在线关注', value: '58万+' },
];